import { render, staticRenderFns } from "./lsdbbk.vue?vue&type=template&id=2d6724f4&scoped=true&"
import script from "./lsdbbk.vue?vue&type=script&lang=js&"
export * from "./lsdbbk.vue?vue&type=script&lang=js&"
import style0 from "./lsdbbk.vue?vue&type=style&index=0&id=2d6724f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6724f4",
  null
  
)

export default component.exports